import React from "react";

const Card = ({ img }) => {
  return <img src={img} alt="" className="Card" />;
};

export default Card;
